import { DpOutlinedSelect } from '@/components/blocks/DpOutlineSelect';
import { FormControl, InputLabel, MenuItem } from '@mui/material';

interface Props {
	value: string;
	sizes: string[];
	category: string;
	onChange: (event: any) => void;
}

const getLabel = (category: string) => {
	switch (category) {
		case 'GENDER':
			return 'Elige tu género';
		case 'BIRTHDAY':
			return 'Fecha de nacimiento';
		default:
			return 'Talla preferida';
	}
};

export const AccountPreferredSizesSelect: React.FC<Props> = ({
	value,
	sizes,
	category,
	onChange,
}) => (
	<FormControl variant="outlined" fullWidth sx={{ marginTop: '15px' }}>
		<InputLabel
			id="select-preferred-size-label"
			sx={{
				top: '-4px',
				'&.MuiInputLabel-shrink': {
					top: '0',
				},
			}}
		>
			{getLabel(category)}
		</InputLabel>
		<DpOutlinedSelect
			labelId="select-preferred-size-label"
			id="select-preferred-size-label"
			name="preferredSize"
			label={getLabel(category)}
			fullWidth
			value={value}
			onChange={onChange}
		>
			<MenuItem value="">
				<em>Seleccione</em>
			</MenuItem>
			{sizes.map((size) => (
				<MenuItem key={size} value={size} translate="no">
					{size}
				</MenuItem>
			))}
		</DpOutlinedSelect>
	</FormControl>
);
